import { useState, useEffect } from "react";
import { get } from "../http/api";
import { FaUser, FaPlay } from "react-icons/fa";
import "./SharedPost.css";
import { getMediaUrl } from "../http/media";

export default function SharedPost({ postId, onOpenPost }) {
    const [post, setPost] = useState(null);
    const ownerPhoto = post?.owner_photo || post?.user_image || post?.user_photo;
    const ownerUsername = post?.owner_username || post?.username;

    useEffect(() => {
        fetchPost();
    }, [postId]);

    const fetchPost = async () => {
        try {
            const res = await get(`posts/${postId}`);
            setPost(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    if (!post) {
        return (
            <div className="shared-post-skeleton">
                ...
            </div>
        );
    }

    return (
        <>
            <div className="shared-post-card" onClick={() => onOpenPost(post.id_post)}>
                <div className="shared-post-header">
                    <div className="shared-post-avatar">
                        {ownerPhoto ? (
                            <img
                                src={getMediaUrl(ownerPhoto)}
                                alt={ownerUsername || ""}
                            />
                        ) : (
                            <FaUser />
                        )}
                    </div>

                    <strong>{ownerUsername}</strong>
                </div>

                {post.text && (
                    <p className="shared-post-text">
                        {post.text}
                    </p>
                )}

                {post.type === "image" && post.image && (
                    <img
                        className="shared-post-image"
                        src={getMediaUrl(post.image)}
                        // src={`${UPLOADS_URL}/${post.image}`}
                        alt=""
                    />
                )}

                {post.type === "video" && post.video && (
                    <div
                        className="shared-video-preview"
                    >
                        <video
                            className="shared-video-thumb"
                            muted
                            playsInline
                            preload="metadata"
                            onLoadedData={(e) => {
                                e.currentTarget.currentTime = 0.1;
                            }}
                        >
                            <source
                                src={getMediaUrl(post.video, "video")}
                                // src={`${UPLOADS_URL}/videos/${post.video}`}
                                type="video/mp4"
                            />
                        </video>

                        <div className="video-overlay"></div>

                        <div className="video-play-btn">
                            <FaPlay />
                        </div>
                    </div>
                )}
            </div>

        </>
    );
}
